import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { ButtonModule } from "primeng/button";;
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { DividerModule } from "primeng/divider";
import { FormsModule } from "@angular/forms";
import { MessagesModule } from "primeng/messages";
import { FormatPipeModule } from "src/app/admihair/format-pipe/format-pipe.module";
import { TreeTableModule } from "primeng/treetable";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { UsuarioFranquiaRfariasDetalharComponent } from "./usuario-franquia-rfarias-detalhar.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ButtonModule,
        InputTextModule,
        TableModule,
        HttpClientModule,   
        DividerModule,
        MessagesModule,
        FormatPipeModule,
        TreeTableModule,
        ProgressSpinnerModule,
    ],
    declarations: [UsuarioFranquiaRfariasDetalharComponent],
    exports: [UsuarioFranquiaRfariasDetalharComponent]
})
export class UsuarioFranquiaRfariasDetalharModule { }
